import { render, staticRenderFns } from "./from-comm.vue?vue&type=template&id=1e2e3da6&scoped=true&"
import script from "./from-comm.vue?vue&type=script&lang=js&"
export * from "./from-comm.vue?vue&type=script&lang=js&"
import style0 from "./from-comm.vue?vue&type=style&index=0&id=1e2e3da6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2e3da6",
  null
  
)

export default component.exports